__webpack_require__.p = "/wp-content/themes/buehrer-wohnen.ch/dist/";